export default __webpack_public_path__ + "static/media/educator-banner-mobile.f7812b24.webp";